import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import numeral from "numeral";
import { Paper } from "@material-ui/core";
import * as d3 from 'd3';


const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  panel: {
    paddingLeft: 0
  }
});


class GaugeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  createVisualization() {

    const container = '#' + this.makeContainerName();

    let { value, targetValue, width, height } = this.props;

    let percentage = (value / targetValue) * 100;
    let ratio = percentage / 100;
    let fill = Math.PI * ratio;

    let r = width / 3;
    let arc = d3.svg.arc()
      .innerRadius(r)
      .outerRadius(r + 21)
      .startAngle(0)
      .endAngle(Math.PI);

    let arcLine = d3.svg.arc()
      .innerRadius(r)
      .outerRadius(r + 21)
      .startAngle(0)
      .endAngle(fill);

    d3.select(container).selectAll("*").remove();

    let svg = d3.select(container).append("svg")
      .attr("width", width)
      .attr("height", height - (height * .42))
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    let background = svg.append("path")
      .attr("d", arc)
      .attr("transform", "rotate(-90)")
      .style("fill", "silver");

    let fillPath = svg.append("path")
      .attr("d", arcLine)
      .attr("transform", "rotate(-90)")
      .attr("fill", "#990099")

    let label = svg.append("text")
      .text(Math.round(percentage) + "%")
      .attr("dy", ".75em")
      .style("font-size", "30px")
      .style("font-weight", "bold")
      .style("text-anchor", "middle")
      .attr("y", "-25")

  }

  componentDidUpdate() {
    this.createVisualization();
  }

  componentDidMount() {
    this.createVisualization();
  }

  makeContainerName() {
    return `${this.props.id}_gc`;
  }
  render() {
    let { classes, label, value, format } = this.props;

    return (
      <div id={this.props.id} className={classes.root}>
        <Paper className={classes.paper}>
          <Typography variant="display1" component="h3" align="center">
            <div id={this.makeContainerName()} />
          </Typography>
          <Typography component="p">
            {label}
          </Typography>
        </Paper>
      </div>
    );
  }
}


export default withStyles(styles)(GaugeView);



// WEBPACK FOOTER //
// ./src/components/GaugeView.js